import { createFileRoute, Navigate } from '@tanstack/react-router';
import LoginPage from '@/pages/LoginPage';
import { useMockAuth } from '@/hooks/useMockAuth';

export const Route = createFileRoute('/login')({
  component: LoginRoute,
});

function LoginRoute() {
  const { isAuthenticated } = useMockAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <LoginPage />;
}
